import * as React from 'react';

import {
  ButtonContainer,
  Container,
  SubtitleText,
  TextContainer,
  TitleText
} from './AdditionalOptionQuestion.styled';
import { Button } from 'components/v2/Buttons/Button/Button';

import { ConsentOption } from '../InformedConsent.types';

type Props = {
  option: ConsentOption;
  onSelect: (option: ConsentOption) => Promise<void>;
  partnerDecisionOptionId?: number;
  partnersToMismatch: boolean | null;
};

export const AdditionalOptionQuestion = ({
  option,
  partnerDecisionOptionId,
  onSelect,
  partnersToMismatch
}: Props): React.JSX.Element => {
  const { id, name, description } = option;

  const partnerSelectedThisOption = partnerDecisionOptionId === Number(id);
  const buttonText = `Select this option ${partnerSelectedThisOption ? '*' : ''}`;

  const isDisabled = shouldDisableButton(
    partnerDecisionOptionId,
    partnerSelectedThisOption,
    partnersToMismatch
  );

  return (
    <Container>
      <TextContainer>
        <TitleText>{name}</TitleText>
        <SubtitleText>{description}</SubtitleText>
      </TextContainer>
      <ButtonContainer>
        <Button
          label={buttonText}
          category="primary"
          size="lg"
          fullWidth
          isDisabled={isDisabled}
          onClick={() => onSelect(option)}
        />
        {partnerSelectedThisOption && (
          <SubtitleText>* Your partner has selected this option.</SubtitleText>
        )}
      </ButtonContainer>
    </Container>
  );
};

const shouldDisableButton = (
  partnerDecisionOptionId: number | undefined,
  partnerSelectedThisOption: boolean,
  partnersToMismatch: boolean | null
) => {
  if (!partnerDecisionOptionId || partnersToMismatch == null) return false;

  // if they need to mismatch
  // disable if partner did select this option
  // if they need to match
  // disable if partner did not select this option
  return partnersToMismatch ? partnerSelectedThisOption : !partnerSelectedThisOption;
};
